import { SocialLanguageField } from '@app/modules/social-export/components/inputs/SocialLanguageField';
import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { YoutubeSettingsDto } from '../../social-export.types';
import { YoutubeCategoryField } from './YoutubeCategoryField';
import { YoutubeMadeForKidsField } from './YoutubeMadeForKidsField';
import { YoutubePrivacyStatusField } from './YoutubePrivacyStatusField';

const requiredMsg = defineMessage({ id: 'common.required', defaultMessage: 'Requerido' });

export function getYoutubeSettingsSchema(t: (msg: typeof requiredMsg) => string) {
  return z.object({
    privacyStatus: z.string().min(1, t(requiredMsg)),
    language: z
      .string()
      .nullable()
      .optional()
      .transform((val) => (val === '' ? null : val)),
    madeForKids: z.boolean(),
    categoryId: z
      .string()
      .nullable()
      .optional()
      .transform((val) => (val === '' ? null : val)),
  });
}

/** @deprecated Use getYoutubeSettingsSchema(t) for translated messages */
export const youtubeSettingsSchema = getYoutubeSettingsSchema((msg) => msg.defaultMessage);

export function YoutubeSettingsForm({
  connectionId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<YoutubeSettingsDto>) {
  const { $t } = useIntl();
  const schema = useMemo(() => getYoutubeSettingsSchema((msg) => $t(msg)), [$t]);
  return (
    <PlatformSettingsFormShell
      values={{
        language: defaultSettings.language,
        privacyStatus: defaultSettings.privacyStatus,
        madeForKids: defaultSettings.madeForKids ?? false,
        categoryId: defaultSettings.categoryId,
      }}
      schema={schema}
      onSuccess={async (formData) => {
        await onUpdate({
          privacyStatus: formData.privacyStatus,
          madeForKids: formData.madeForKids,
          language: formData.language,
          categoryId: formData.categoryId,
        });
      }}
    >
      <Grid container>
        <Grid item md={4}>
          <YoutubePrivacyStatusField />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={4}>
          <YoutubeCategoryField connectionId={connectionId} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={4}>
          <SocialLanguageField />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={4}>
          <YoutubeMadeForKidsField />
        </Grid>
      </Grid>
    </PlatformSettingsFormShell>
  );
}
